export {default as Example} from './modules/Example';
export {default as Scroll} from './modules/Scroll';
export {default as Navbar} from './modules/Navbar';
export {default as Subnav} from './modules/Subnav';
export {default as AnchorsNav} from './modules/AnchorsNav';
export {default as Video} from './modules/Video';
export {default as HomeVideo} from './modules/HomeVideo';
export {default as Tabs} from './modules/Tabs';
export {default as SolutionsSlider} from './modules/SolutionsSlider';
export {default as Player} from './modules/Player';
export {default as Collapse} from './modules/Collapse';
export {default as TestimonialsSlider} from './modules/TestimonialsSlider';
export {default as TestimonialsVideos} from './modules/TestimonialsVideos';
export {default as BeforeAfter} from './modules/BeforeAfter';
export {default as Rotator} from './modules/Rotator';
export {default as Search} from './modules/Search';
export {default as Article} from './modules/Article';
export {default as Hubspot} from './modules/Hubspot';
export {default as WebinarCarousel} from './modules/WebinarCarousel';
export {default as Gallery} from './modules/Gallery';
export {default as Playlist} from './modules/Playlist';
export {default as TextReveal} from './modules/TextReveal';
export {default as CardsList} from './modules/CardsList';
export {default as Lightbox} from './modules/Lightbox';
export {default as Timeline} from './modules/Timeline';
export {default as Popup} from './modules/Popup';
export {default as PageOnboarding} from './modules/PageOnboarding';
export {default as Guideflow} from './modules/Guideflow';
export {default as Ideas} from './modules/Ideas';
